var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 100,
    viewBox: "0 0 187 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_225_832)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H187V187H0V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.245 184.196V2.80371H2.74512V184.196H184.245Z",
    fill: "#002C5C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.1 49.6798H136.845C140.483 49.5731 142.045 52.9006 142.045 55.5005V94.4798C142.152 97.2835 140.483 99.8834 137.262 99.8834H133.1V49.6798ZM136.952 48.2246H121.983V49.6798H125.931V137.311H121.983V138.872H138.824V137.311H133.11V101.659H138.097C145.169 101.659 149.224 97.9141 149.224 92.8209V57.79C149.224 52.6969 145.79 48.2246 136.962 48.2246H136.952Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.741 49.3693C57.741 50.8244 56.9067 50.7177 56.2858 50.2036C53.7926 48.5447 50.8823 47.2932 48.1757 47.2932C43.8101 47.2932 37.679 49.476 37.5723 58.6242V125.776C37.679 137.524 43.2863 139.707 48.7965 139.707C53.1621 139.813 55.2381 137.524 56.9067 136.69C57.838 136.379 58.8858 137.213 58.8858 138.979H60.6514V96.2551H64.2893V94.7999H49.1167V96.2551H53.4822V132.945C53.4822 135.962 51.5032 138.242 48.9129 138.242C46.3227 138.242 44.5474 135.855 44.5474 132.945V55.9176C44.5474 53.8415 44.9646 48.9521 48.1854 48.9521C54.4232 48.9521 57.7507 67.2485 57.7507 76.7072H59.5163V48.1178H57.7507V49.3693H57.741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.2832 99.9901L89.6487 60.7974L94.1209 99.9901H85.2832ZM94.3343 101.552L98.3894 137.311H94.4411V138.872H109.41V137.311H105.462L95.4791 48.1179H89.1345L79.7826 132.314C79.2587 135.332 79.055 137.204 74.6895 137.301V138.863H85.9137V137.301C82.6929 137.301 81.2378 135.225 81.5482 133.139L85.0794 101.542H94.3343V101.552Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_225_832"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 187,
    height: 187,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGap);
export default __webpack_public_path__ + "static/media/Gap.4601e24905968dd88113669631c0cf78.svg";
export { ForwardRef as ReactComponent };